import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { isValueEmpty, isJsonString } from '@awp/helpers/utilsReact';
import { ModelMetaFields } from '@awp/components/MetaFields/ModelMetaFields';

import { selectAllSensormodels, getjsonObject } from '@stores/sensorEquipmentSlice';
//a blank small column
const blankColumn = {
  //maxWidth: "2rem",
  display: 'inline-block',
};
const colStyle = {
  display: 'inline-block',
  paddingLeft: '0rem',
};
const colStyle1 = {
  display: 'inline-block',
};
const prefix = 'meta_field';

const ModelMetaBoxEdit = ({ sensor, setSensorData, fieldErrors, setFieldErrors, props }) => {
  const sensormodelList = useSelector(selectAllSensormodels);
  const jsonObj = getjsonObject(sensor, sensormodelList);
  return (
    <>
      {jsonObj && jsonObj.properties && Object.keys(jsonObj.properties).length > 0 && (
        <>
          {Object.keys(jsonObj.properties)
            .reduce(function (accumulator, currentValue, currentIndex, array) {
              if (currentIndex % 3 === 0) accumulator.push(array.slice(currentIndex, currentIndex + 3));
              return accumulator;
            }, [])
            .map((p, i) => {
              if (isValueEmpty(p)) return;
              let p1 = jsonObj.properties[p[0]];
              let p2 = jsonObj.properties[p[1]];
              let p3 = jsonObj.properties[p[2]];
              return (
                <Row key={`${prefix}_${sensor.Id}_div_${i}`}>
                  {/* <Col key={`${prefix}_${sensor.Id}_col_blank_${i}`} md={1} style={blankColumn} /> */}
                  <Col key={`${prefix}_${sensor.Id}_col_${i}-1`} className="mb-4" sm={4} style={colStyle1}>
                    {p1 && (
                      <ModelMetaFields
                        key={`${prefix}_${sensor.Id}_mf_jobj_${i}-1`}
                        id={`${prefix}_${sensor.Id}_mf_jobj_${i}-1`}
                        objName={p[0]}
                        sensor={sensor}
                        setSensorData={setSensorData}
                        fieldErrors={fieldErrors}
                        setFieldErrors={setFieldErrors}
                        props={props}
                        index={`${prefix}_${sensor.Id}_mf_jobj_${i}-1`}
                      />
                    )}
                  </Col>
                  <Col key={`${prefix}_${sensor.Id}_col_${i}-2`} className="mb-4" sm={4} style={colStyle1}>
                    {p2 && (
                      <ModelMetaFields
                        key={`${prefix}_${sensor.Id}_mf_jobj_${i}-2`}
                        id={`${prefix}_${sensor.Id}_mf_jobj_${i}-2`}
                        objName={p[1]}
                        sensor={sensor}
                        setSensorData={setSensorData}
                        fieldErrors={fieldErrors}
                        setFieldErrors={setFieldErrors}
                        props={props}
                        index={`${prefix}_${sensor.Id}_mf_jobj_${i}-2`}
                      />
                    )}
                  </Col>
                  <Col key={`${prefix}_${sensor.Id}_col_${i}-3`} className="mb-4" sm={4} style={colStyle1}>
                    {p3 && (
                      <ModelMetaFields
                        key={`${prefix}_${sensor.Id}_mf_jobj_${i}-3`}
                        id={`${prefix}_${sensor.Id}_mf_jobj_${i}-3`}
                        objName={p[2]}
                        sensor={sensor}
                        setSensorData={setSensorData}
                        fieldErrors={fieldErrors}
                        setFieldErrors={setFieldErrors}
                        props={props}
                        index={`${prefix}_${sensor.Id}_mf_jobj_${i}-3`}
                      />
                    )}
                  </Col>
                </Row>
              );
            })}
        </>
      )}
    </>
  );
};

ModelMetaBoxEdit.propTypes = {
  sensor: PropTypes.any.isRequired,
  setSensorData: PropTypes.any.isRequired,
};

export default ModelMetaBoxEdit;
